export default __webpack_public_path__ + "static/media/MILAF_Site_Logo.623e0bcd.png";